module.exports = __webpack_public_path__ + "static/media/powered-by-finkraft-dark-text.d5f4238d.svg";